import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import Stack from "@mui/material/Stack";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { ConnectAccountOnboarding, ConnectComponentsProvider } from "@stripe/react-connect-js";
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";

function CardInfoForm({ handleSetupClose, cancelSetupIntent, getPaymentMethods }) {
  const { t } = useTranslation("pages");
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState("");
  const handleSubmit = async () => {
    if (!stripe || !elements) {
      return null;
    }

    const { error } = await stripe.confirmSetup({
      elements,
      redirect: "if_required",
      confirmParams: {
        return_url: "",
      },
    });

    if (error) {
      setErrorMessage(error.message);
    } else {
    }
    handleSetupClose();
    getPaymentMethods();
  };
  return (
    <MDBox
      p={5}
      position="absolute"
      color="white"
      bgColor="white"
      transform="translate(-50%, -50%)"
    >
      <Stack spacing={5} direction="column">
        <PaymentElement />
        <MDButton
          p={5}
          variant="gradient"
          color="success"
          onClick={() => {
            handleSubmit();
          }}
        >
          {t("accountUi.save")}
        </MDButton>
        <MDButton
          p={5}
          variant="gradient"
          color="dark"
          onClick={async () => {
            await cancelSetupIntent();
            handleSetupClose();
          }}
        >
          {t("accountUi.cancel")}
        </MDButton>
        {errorMessage && <div>{errorMessage}</div>}
      </Stack>
    </MDBox>
  );
}

CardInfoForm.propTypes = {
  handleSetupClose: PropTypes.func,
  cancelSetupIntent: PropTypes.func,
  getPaymentMethods: PropTypes.func,
};

export default CardInfoForm;
